import React, { useState } from "react";
import ContenidoOpcionesComponent from "./contenido_opciones.component";
/* import ContenidoMapaOlComponent from "./contenido_mapa_ol.component"; */
import ContenidoMapaComponent from "./contenido_mapa.component";
import CityComponent from "./city.component";
import ModalComponent from "./modal.component";
import dolty from "../../assets/icon_mapa/doty-dealer-of-the-year-2024.webp";

/*eslint-disable */

interface ContenidoComponentProps {
  concesionarios: any;
}

declare const window: any;
const ContenidoComponent: React.FC<ContenidoComponentProps> = ({
  concesionarios,
}) => {
  const [ciudad, setCiudad] = useState("todo");
  const [vitrina, setVitrina] = useState("ventas/taller");
  const [vehiculo, setVehiculo] = useState("todo");
  const [palabra, setPalabra] = useState("");
  const [selectedConcesionarios, setSelectedConcesionarios] = useState([]);
  const [mylocation, setMylocation] = useState(true);
  const [isModalOpen, setModalOpen] = useState(false);

  const handleOpenModal = () => setModalOpen(true);
  const handleCloseModal = () => setModalOpen(false);
  return (
    <div className="contenido-concesionarios-component">
      <ContenidoOpcionesComponent
        ciudad={ciudad}
        setCiudad={setCiudad}
        vitrina={vitrina}
        setVitrina={setVitrina}
        vehiculo={vehiculo}
        setVehiculo={setVehiculo}
        concesionarios={concesionarios}
        selectedConcesionarios={selectedConcesionarios}
        setSelectedConcesionarios={setSelectedConcesionarios}
        setPalabra={setPalabra}
        palabra={palabra}
        setMylocation={setMylocation}
        mylocation={mylocation}
        handleOpenModal={handleOpenModal}
      />
      <ContenidoMapaComponent
        ciudad={ciudad}
        selectedConcesionarios={selectedConcesionarios}
        mylocation={mylocation}
        setCiudad={setCiudad}
      />
      <CityComponent setCiudad={setCiudad} />
      {/* <ContenidoMapaOlComponent /> */}
      <ModalComponent isOpen={isModalOpen} onClose={handleCloseModal}>
        <div className="dolty-modal-container">
          <div className="img-dolty-modal-container">
            <img src={dolty} alt="" />
          </div>
          <div className="txt-dolty-modal-container">
            <div className="title-txt-dolty-modal-container">Hyundai DOTY</div>
            <div className="description-txt-dolty-modal-container">
              Este concesionario ha sido seleccionado como uno de los "100
              mejores concesionarios del mundo" por sus excelentes resultados en
              ventas, servicio al cliente e instalaciones.
            </div>
          </div>
        </div>
      </ModalComponent>
    </div>
  );
};

export default ContenidoComponent;
